// 获取区分普通租户()和工商租户(2)
let vendorVal = localStorage.getItem("vendor");
if (!vendorVal) {
  vendorVal = null;
}

// 获取identity(身份) - 区分商户(1)和员工(2)
let identityVal = localStorage.getItem("identity");
if (!identityVal) {
  identityVal = "";
}

// 获取token
let tokenVal = localStorage.getItem("token");
if (!tokenVal) {
  tokenVal = "";
}

// 获取shopId
let shopIdVal = localStorage.getItem("shopId");
if (!shopIdVal) {
  shopIdVal = "";
}

// 获取用户名
let usernameVal = localStorage.getItem("username");
if (!usernameVal) {
  usernameVal = "";
}

// 获取面包屑导航
let crumbsNavValArr = JSON.parse(localStorage.getItem("crumbsNav"));
if (!crumbsNavValArr) {
  crumbsNavValArr = [];
}

// 获取权限
let jurisdictionValObj = JSON.parse(localStorage.getItem("jurisdiction"));
if (!jurisdictionValObj) {
  jurisdictionValObj = {};
}

// 获取套餐
let comboValObj = JSON.parse(localStorage.getItem("combo"));
if (!comboValObj) {
  comboValObj = {};
}

// 监测侧边菜单宽
let changWidthBel = false;

export default {
  vendor: vendorVal,
  identity: identityVal,
  token: tokenVal,
  shopId: shopIdVal,
  username: usernameVal,
  crumbsNav: crumbsNavValArr,
  jurisdiction: jurisdictionValObj,
  combo: comboValObj,
  changWidth: changWidthBel,
};



// WEBPACK FOOTER //
// ./src/store/state.js